
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import styles from '../../styles/home/primeStrategySection.module.scss';
import MainButton from "../Button";
export default function PrimeStrategySection() {
    const features = [
        "Core trading strategy",
        "Market-tested execution logic",
        "Recognized strategy framework",
        "Proven performance history",
        "KYB-verified entity"
    ];
    return (<section className={styles.primeStrategySection}>
            <div className={styles.container}>
                <div className={styles.leftSection}>
                    {/* Decorative vector group - positioned relative to leftSection */}
                    <div className={styles.vectorGroup}>
                        <img src="/images/prime/vector-group.svg" alt="" role="presentation"/>
                    </div>

                    <div className={styles.leftSectionContainer}>
                        <div className={styles.leftSectionContent}>
                            <div className={styles.titleContainer}>
                                <div className={styles.tagContainer}>
                                    <p className={styles.tag}>Prime</p>
                                </div>
                                <p className={styles.leftTitle}>Prime Strategy</p>
                            </div>

                            <div className={styles.featuresList}>
                                {features.map((feature, index) => (<div key={index} className={styles.featureItem}>
                                        <div className={styles.checkmarkIcon}>
                                            <img src="/images/prime/checkmark.svg" alt="Checkmark"/>
                                        </div>
                                        <p className={styles.featureText}>{feature}</p>
                                    </div>))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.rightSection}>
                    <div className={styles.rightSectionContent}>
                        <h2 className={styles.mainTitle}>
                            Protocol-curated<br />
                            trading strategies
                        </h2>
                        <p className={styles.description}>
                            Each strategy is validated against predefined performance, security, and risk parameters before being approved for deployment.
                        </p>
                    </div>
                    <MainButton action={'/invest'} text={'Choose your strategy'}/>
                </div>
            </div>
        </section>);
}

    async function __Next_Translate__getStaticProps__1a17ab3f3d2__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//PrimeStrategySection',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a17ab3f3d2__ as getStaticProps }
  